import { lang } from "./Lang";

const DEFAULT_OPTION_IDS = {
    hardness: parseInt(process.env.REACT_APP_HARDNESS_OPTION_ID),
    size: parseInt(process.env.REACT_APP_MATTRESS_SIZE_OPTION_ID),
    builtInMattress: parseInt(process.env.REACT_APP_BUILTIN_MATTRESS_OPTION_ID),
    builtInMattressHardness: parseInt(process.env.REACT_APP_BUILTIN_MATTRESS_HARDNESS_OPTION_ID),
    mattressWithBed: parseInt(process.env.REACT_APP_MATTRESS_WITH_BED_OPTION_ID) || 169,
};

const OPTION_IDS_BY_LANG = {
    de: {
        hardness: parseInt(process.env.REACT_APP_DE_HARDNESS_OPTION_ID) || 150,
        size: parseInt(process.env.REACT_APP_DE_MATTRESS_SIZE_OPTION_ID) || 149,
        builtInMattress: parseInt(process.env.REACT_APP_DE_BUILTIN_MATTRESS_OPTION_ID) || 135,
        builtInMattressHardness: parseInt(process.env.REACT_APP_DE_BUILTIN_MATTRESS_HARDNESS_OPTION_ID) || 138,
        mattressWithBed: parseInt(process.env.REACT_APP_DE_MATTRESS_WITH_BED_OPTION_ID) || DEFAULT_OPTION_IDS.mattressWithBed,
    },
};

const overrides = OPTION_IDS_BY_LANG[lang.current] || {};

export const MATTRESS_HARDNESS_OPTION_ID = overrides.hardness || DEFAULT_OPTION_IDS.hardness;
export const MATTRESS_SIZE_OPTION_ID = overrides.size || DEFAULT_OPTION_IDS.size;
export const BUILT_IN_MATTRESS_OPTION_ID = overrides.builtInMattress || DEFAULT_OPTION_IDS.builtInMattress;
export const BUILT_IN_MATTRESS_HARDNESS_OPTION_ID = overrides.builtInMattressHardness || DEFAULT_OPTION_IDS.builtInMattressHardness;
export const MATTRESS_WITH_BED_OPTION_ID = overrides.mattressWithBed || DEFAULT_OPTION_IDS.mattressWithBed;

/**
 * MYB-144: discount applied to a mattress bought together with the bed.
 */
export const MATTRESS_WITH_BED_DISCOUNT = 0.1;

console.log({
    lang: lang.current,
    MATTRESS_HARDNESS_OPTION_ID,
    MATTRESS_SIZE_OPTION_ID,
    BUILT_IN_MATTRESS_OPTION_ID,
    BUILT_IN_MATTRESS_HARDNESS_OPTION_ID,
    MATTRESS_WITH_BED_OPTION_ID,
});
